<template>
  <calendar-week :interactive="true" :comp-allow="allowWeekDay"  />
</template>

<script>
import moment from 'moment'
import CalendarWeek from '../components/CalendarWeek.vue'
export default {
  name: 'dashboard',
  components: { CalendarWeek },
  data() {
    return {

    }
  },
  methods: {
    allowWeekDay(value) {
      return moment(value).day() == 5
    },
  }
}
</script>

<style scoped>

</style>
